// Packages
import { useLocation } from "react-router-dom";

// Components
import { Banner, SiteHeader } from "@jkast90/kast-common/ui";
import { banners } from "../../banner";
import { AccountControls } from "../../accountKit";

// Assets
import kindlyLogo from "../../assets/kindly_logo.webp";

// Styling
import styles from "./NavBar.module.css";

const LINKS = [
  { href: "/wishlist", label: "Wishes" },
  { href: "/memories", label: "Memories" },
  { href: "/calendar", label: "Events" },
  { href: "/yearly-summary", label: "Letter" },
  { href: "/feed", label: "Feed" },
];

export default function NavBar({ onHelpClick }: { onHelpClick: () => void }) {
  const { pathname } = useLocation();

  return (
    <div className={styles.navbar}>
      <SiteHeader
        className={styles.header}
        brand={{ logo: kindlyLogo, alt: "Home" }}
        onHelp={onHelpClick}
        links={LINKS}
        stackBelow={768}
        activeHref={pathname}
        account={<AccountControls />}
      />
      <Banner store={banners} className={styles.banners} />
    </div>
  );
}
